module.exports = __webpack_public_path__ + "img/25-image-2-1@2x.9262931c.png";